import { setFullTextDocumentIdType } from './HopintoConstants';

export function setFullTextDocumentId(payload) {
  return {
    type: setFullTextDocumentIdType,
    payload
  };
}
